import {
  Sidebar,
  SidebarDivider,
  SidebarGroup,
  SidebarItem,
  SidebarScrollWrapper,
  SidebarSpace,
} from '@backstage/core-components';
import { NavContentBlueprint } from '@backstage/plugin-app-react';
import { SidebarLogo } from './SidebarLogo';
import MenuIcon from '@material-ui/icons/Menu';
import AccountTreeIcon from '@material-ui/icons/AccountTree';
import CloudQueueIcon from '@material-ui/icons/CloudQueue';
import GroupIcon from '@material-ui/icons/Group';
import PersonIcon from '@material-ui/icons/Person';
import SecurityIcon from '@material-ui/icons/Security';
import SearchIcon from '@material-ui/icons/Search';
import { SidebarSearchModal } from '@backstage/plugin-search';
import { UserSettingsSignInAvatar } from '@backstage/plugin-user-settings';
import { NotificationsSidebarItem } from '@backstage/plugin-notifications';
import { configApiRef, useApi } from '@backstage/core-plugin-api';

export const SidebarContent = NavContentBlueprint.make({
  params: {
    component: function SidebarNavigation({ navItems }) {
      const config = useApi(configApiRef);
      const securityV2Enabled =
        config.getOptionalBoolean('app.securityV2Enabled') ?? false;
      const nav = navItems.withComponent(item => (
        <SidebarItem icon={() => item.icon} to={item.href} text={item.title} />
      ));

      // Skipped items
      nav.take('page:search'); // Using search modal instead
      nav.take('page:app/catalog-users'); // Custom sidebar placement
      nav.take('page:app/catalog-groups'); // Custom sidebar placement
      nav.take('page:app/environments'); // Custom sidebar placement
      nav.take('page:app/security'); // Custom sidebar placement
      nav.take('page:app/security-v2'); // Custom sidebar placement
      nav.take('page:app/security-v2-service'); // Detail routes are not navigation entries
      nav.take('page:catalog-graph'); // Custom root entity for the global graph
      nav.take('page:notifications'); // Custom sidebar placement

      return (
        <Sidebar>
          <SidebarLogo />
          <SidebarGroup label="Search" icon={<SearchIcon />} to="/search">
            <SidebarSearchModal />
          </SidebarGroup>
          <SidebarDivider />
          <SidebarGroup label="Menu" icon={<MenuIcon />}>
            {nav.take('page:catalog')}
            <SidebarItem icon={PersonIcon} to="/catalog/users" text="Users" />
            <SidebarItem icon={GroupIcon} to="/catalog/groups" text="Groups" />
            {nav.take('page:scaffolder')}
            <SidebarItem
              icon={CloudQueueIcon}
              to="/environments"
              text="Environments"
            />
            <SidebarItem icon={SecurityIcon} to="/security" text="Security" />
            {securityV2Enabled && (
              <SidebarItem
                icon={SecurityIcon}
                to="/security-v2"
                text="Security v2"
              />
            )}
            <SidebarItem
              icon={AccountTreeIcon}
              to="/catalog-graph?rootEntityRefs%5B%5D=system%3Adefault%2Fander2&maxDepth=2&unidirectional=true&mergeRelations=true&direction=LR&showFilters=true&curve=curveMonotoneX"
              text="Catalog Graph"
            />
            <SidebarDivider />
            <SidebarScrollWrapper>
              {nav.rest({ sortBy: 'title' })}
            </SidebarScrollWrapper>
          </SidebarGroup>
          <SidebarSpace />
          <SidebarDivider />
          <NotificationsSidebarItem />
          <SidebarDivider />
          <SidebarGroup
            label="Settings"
            icon={<UserSettingsSignInAvatar />}
            to="/settings"
          >
            {nav.take('page:app-visualizer')}
            {nav.take('page:user-settings')}
          </SidebarGroup>
        </Sidebar>
      );
    },
  },
});
